import * as Yup from "yup"
import { Consentement, Country, Email, FirstName, LastName, MobilePhoneRequired, Salutation, WishedProgramm } from "services/validation"

const schema = Yup.object().shape({
  ...Consentement,
  lead: Yup.object().shape({
    ...Country,
    ...Email,
    ...FirstName,
    ...LastName,
    ...MobilePhoneRequired,
    ...Salutation,
    ...WishedProgramm,
    AcademicLevel__c: Yup.string().required("Le niveau académique actuel est requis")
  })
})

export default schema
